import {asyncStorage as localforage} from '../constants';

function rejectWithMessage(error) {
  return Promise.reject(error.message);
}

// cloned from npm 'redux-storage-engine-localforage' without the config step
export const createEngine = (key, config = {}, replacer, reviver) => {
  return {
    load() {
      return localforage.getItem(key)
        .then((jsonState) => JSON.parse(jsonState, reviver) || {})
        .catch(rejectWithMessage);
    },

    save(state) {
      return Promise.resolve()
        .then(() => JSON.stringify(state, replacer))
        .then((jsonState) => localforage.setItem(key, jsonState))
        .catch(rejectWithMessage);
    },
  };
};



// WEBPACK FOOTER //
// ./src/js/config/redux-storage/createEngine.js